module.exports = __webpack_public_path__ + "static/media/dianbanre_banner2.520c091b.png";